export default class AddedSportsModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.sports === undefined || content.sports.add === undefined) {
            return;
        }

        const sports = content.sports.add;

        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];

            const key = this._modelKeyRepository.addSport(sport.id);

            sports[i] = Object.assign({
                name: sport.n,
                priority: sport.p,
                eventCount: sport.ec
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/AddedSportsModifier.js